class NostoCarousel extends HTMLElement {
  constructor () {
    super()

    this.elements = {
      sliderComponent: this.querySelector('slider-component'),
      carousel: this.querySelector('[data-nosto-carousel-el="carousel"]'),
      productData: this.querySelector('[data-nosto-carousel-el="productData"]'),
    }
  }

  connectedCallback () {
    this.observeProductData()
  }

  observeProductData () {
    const target = this.elements.productData

    if (!target) return

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          this.renderProductCards()
          observer.disconnect()
        }
      }
    })

    const config = { childList: true, subtree: false }
    observer.observe(target, config)
  }

  async getProductCards () {
    const productData = this.elements.productData.firstElementChild
    const productDataJson = JSON.parse(productData.innerHTML)

    const productCardNodes = await Promise.all(
      productDataJson.products.map(async product => {
        const productCardHTML = await this.getProductCardHTML(product)

        const template = document.createElement('template')
        template.innerHTML = productCardHTML.trim()

        const productCardEl = template.content.querySelector('product-card')

        if (!productCardEl) return

        const listItem = document.createElement('li')
        listItem.classList.add('nosto-item', 'grid__item', 'slider__slide')
        listItem.appendChild(productCardEl)

        return listItem
      }),
    )

    return productCardNodes
  }

  async renderProductCards () {
    const productCardNodes = await this.getProductCards()

    if (!productCardNodes) return

    const fragment = document.createDocumentFragment()
    productCardNodes.forEach(li => fragment.appendChild(li))

    this.elements.carousel.appendChild(fragment)
    this.initialiseSlider()
  }

  async getProductCardHTML (product) {
    const response = await fetch(`/products/${product.handle}/?section_id=product-card`)
    const section = await response.text()

    return section
  }

  initialiseSlider () {
    const slider = this.elements.sliderComponent

    slider.init()
    this.dataset.initialised = true
  }
}

customElements.define('nosto-carousel', NostoCarousel)
